import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "none",
  "fill-rule": "evenodd"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M0 0h24v24H0z" }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "gst-svg-icon",
    d: "M18.4 5.455h-.8v-.728c0-.4-.36-.727-.8-.727-.44 0-.8.327-.8.727v.728H8v-.728C8 4.327 7.64 4 7.2 4c-.44 0-.8.327-.8.727v.728h-.8c-.88 0-1.6.654-1.6 1.454v11.636c0 .8.72 1.455 1.6 1.455h12.8c.88 0 1.6-.655 1.6-1.455V6.91c0-.8-.72-1.454-1.6-1.454Zm-.8 13.09H6.4c-.44 0-.8-.327-.8-.727V9.091h12.8v8.727c0 .4-.36.727-.8.727Z",
    fill: "#23262D",
    "fill-rule": "nonzero"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };